import { Routes } from '@angular/router'
import { BaseComponent } from './core/template/base/base.component'
import { LoginComponent } from './pages/login/login/login.component'
import { AuthGuard } from './core/guards/auth.guard'
import { SupplierPortalGuard } from './core/guards/supplier-portal.guard'
import { SupplierPortalLayoutComponent } from './core/template/supplier-portal-layout/supplier-portal-layout.component'
import { SupplierPortalHomeComponent } from './pages/supplier-portal/supplier-portal-home/supplier-portal-home.component'
import { SupplierPortalOsDetailComponent } from './pages/supplier-portal/supplier-portal-os-detail/supplier-portal-os-detail.component'
import { HomeComponent } from './pages/home/home/home.component'
import { ContactTypeComponent } from './pages/contact/contact-type/contact-type.component'
import { AddressTypeComponent } from './pages/address/address-type/address-type.component'
import { ProfileComponent } from './pages/profile/profile/profile.component'
import { VehicleTypeComponent } from './pages/vehicle/vehicle-type/vehicle-type.component'
import { VehicleModelComponent } from './pages/vehicle/vehicle-model/vehicle-model.component'
import { VehicleBrandComponent } from './pages/vehicle/vehicle-brand/vehicle-brand.component'
import { DriverTypeComponent } from './pages/driver/driver-type/driver-type.component'
import { ServiceTypeComponent } from './pages/service/service-type/service-type.component'
import { ServiceSpecificationComponent } from './pages/service/service-specification/service-specification.component'
import { PaymentTypeComponent } from './pages/payment/payment-type/payment-type.component'
import { EmployeeRoleComponent } from './pages/employee/employee-role/employee-role.component'
import { OccurrenceTypeComponent } from './pages/occurrence/occurrence-type/occurrence-type.component'
import { TaxDocumentTypeComponent } from './pages/tax-document/tax-document-type/tax-document-type.component'
import { TariffTypeComponent } from './pages/tariff/tariff-type/tariff-type.component'
import { PriceQuoteStatusComponent } from './pages/price-quote/price-quote-status/price-quote-status.component'
import { OperationStatusComponent } from './pages/operation/operation-status/operation-status.component'
import { ContractStatusComponent } from './pages/contract/contract-status/contract-status.component'
import { AddressComponent } from './pages/address/address/address.component'
import { ContactComponent } from './pages/contact/contact/contact.component'
import { BankDetailsComponent } from './pages/bank/bank-details/bank-details.component'
import { PaymentMethodsComponent } from './pages/payment/payment-methods/payment-methods.component'
import { PersonTypeComponent } from './pages/person/person-type/person-type.component'
import { ClientComponent } from './pages/customer/client/client.component'
import { BankComponent } from './pages/bank/bank/bank.component'
import { EmployeeStatusComponent } from './pages/employee/employee-status/employee-status.component'
import { EmployeeComponent } from './pages/employee/employee/employee.component'
import { SupplierComponent } from './pages/person/supplier/supplier.component'
import { CoordinatorComponent } from './pages/person/coordinator/coordinator.component'
import { LocationComponent } from './pages/location/location/location.component'
import { DriverComponent } from './pages/driver/driver/driver.component'
import { TariffComponent } from './pages/tariff/tariff/tariff.component'
import { DocumentTypeComponent } from './pages/document/document-type/document-type.component'
import { ProposalClientComponent } from './pages/proposal/proposal-client/proposal-client.component'
import { ProposalStatusComponent } from './pages/proposal/proposal-status/proposal-status.component'
import { ServiceOrderComponent } from './pages/service/service-order/service-order.component'
import { PurchasesQuoteRequestComponent } from './pages/purchases/purchases-quote-request/purchases-quote-request.component'
import { FinancialOperationComponent } from './pages/financial/operation/financial-operation.component'
import { PurchasesQuoteComponent } from './pages/purchases/purchases-quote/purchases-quote.component'
import { ContractComponent } from './pages/contract-proposal/contract-proposal.component'
import { VehicleRegisterComponent } from './pages/vehicle/vehicle-register/vehicle-register/vehicle-register.component'
import { FleetScheduleComponent } from './pages/fleet-schedule/fleet-schedule.component'
import { ServiceAdditionalComponent } from './pages/service/service-additional/service-additional.component'
import { MonitoringComponent } from './pages/monitoring/monitoring.component'
import { MonitoringOsComponent } from './pages/monitoring-os/monitoring-os.component'
import { OccurrencesComponent } from './pages/occurrence/occurrences/occurrences.component'
import { PurchasesComponent } from './pages/purchases/purchases/purchases.component'
import { PurchaseReservationComponent } from './pages/purchase-reservation/purchase-reservation.component'
import { ReasonComponent } from './pages/reason/reason/reason.component'
import { QuoteRefusalReasonComponent } from './pages/purchases/quote-refusal-reason/quote-refusal-reason.component'
import { ImportTariffComponent } from './pages/tariff/import-tariff/import-tariff.component'
import { StretchTypeComponent } from './pages/stretch/stretch-type/stretch-type.component'
import { LogisticsComponent } from './pages/logistics/logistics.component'
import { UserManagementComponent } from './pages/user-management/user-management/user-management.component'

// test
export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'portal-fornecedor',
    component: SupplierPortalLayoutComponent,
    canActivate: [AuthGuard, SupplierPortalGuard],
    children: [
      // ':osId' é catch-all neste nível — qualquer rota filha nomeada precisa vir antes dele.
      { path: '', component: SupplierPortalHomeComponent },
      { path: ':osId', component: SupplierPortalOsDetailComponent },
    ],
  },
  // { path: '**', redirectTo: '/login' },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent,
      },
      // Cadastros
      {
        path: 'banco',
        component: BankComponent,
      },
      {
        path: 'contato',
        component: ContactComponent,
      },
      {
        path: 'dados-bancario',
        component: BankDetailsComponent,
      },
      {
        path: 'endereco',
        component: AddressComponent,
      },
      {
        path: 'especificacao-servico',
        component: ServiceSpecificationComponent,
      },
      {
        path: 'forma-pagamento',
        component: PaymentMethodsComponent,
      },
      {
        path: 'funcao-funcionario',
        component: EmployeeRoleComponent,
      },
      {
        path: 'localizacao',
        component: LocationComponent,
      },
      {
        path: 'marca-veiculo',
        component: VehicleBrandComponent,
      },
      {
        path: 'modelo-veiculo',
        component: VehicleModelComponent,
      },
      {
        path: 'perfil',
        component: ProfileComponent,
      },
      {
        path: 'tarifario',
        component: TariffComponent,
      },
      {
        path: 'importacao-tarifario',
        component: ImportTariffComponent,
      },
      {
        path: 'veiculos',
        component: VehicleRegisterComponent,
      },
      {
        path: 'servico-adicional',
        component: ServiceAdditionalComponent,
      },
      {
        path: 'motivos',
        component: ReasonComponent,
      },
      {
        path: 'motivos-recusa-cotacao',
        component: QuoteRefusalReasonComponent,
      },
      {
        path: 'gerenciamento-usuarios',
        component: UserManagementComponent,
      },
      // Tipos
      {
        path: 'tipo-contato',
        component: ContactTypeComponent,
      },
      {
        path: 'tipo-documento',
        component: DocumentTypeComponent,
      },
      {
        path: 'tipo-documento-fiscal',
        component: TaxDocumentTypeComponent,
      },
      {
        path: 'tipo-endereco',
        component: AddressTypeComponent,
      },
      {
        path: 'tipo-motorista',
        component: DriverTypeComponent,
      },
      {
        path: 'tipo-ocorrencia',
        component: OccurrenceTypeComponent,
      },
      {
        path: 'tipo-pagamento',
        component: PaymentTypeComponent,
      },
      {
        path: 'tipo-pessoa',
        component: PersonTypeComponent,
      },
      {
        path: 'tipo-servico',
        component: ServiceTypeComponent,
      },
      {
        path: 'tipo-tarifario',
        component: TariffTypeComponent,
      },
      {
        path: 'tipo-trecho',
        component: StretchTypeComponent,
      },
      {
        path: 'tipo-veiculo',
        component: VehicleTypeComponent,
      },
      // Status
      {
        path: 'status-contrato',
        component: ContractStatusComponent,
      },
      {
        path: 'status-cotacao',
        component: PriceQuoteStatusComponent,
      },
      {
        path: 'status-funcionario',
        component: EmployeeStatusComponent,
      },
      {
        path: 'status-operacao',
        component: OperationStatusComponent,
      },
      {
        path: 'status-proposta',
        component: ProposalStatusComponent,
      },
      // Pessoa
      {
        path: 'cliente',
        component: ClientComponent,
      },
      {
        path: 'fornecedor',
        component: SupplierComponent,
      },
      {
        path: 'funcionario',
        component: EmployeeComponent,
      },
      {
        path: 'motorista',
        component: DriverComponent,
      },
      {
        path: 'coordenador',
        component: CoordinatorComponent,
      },
      // {
      //   path: 'cliente-juridica',
      //   component: LegalEntityClientComponent,
      // },
      // {
      //   path: 'pessoa-fisica',
      //   component: PersonNaturalComponent,
      // },
      // {
      //   path: 'pessoa-juridica',
      //   component: PersonLegalComponent,
      // },
      //Proposta
      {
        path: 'proposta-cliente',
        component: ProposalClientComponent,
      },
      {
        path: 'solicitacao-cotacao',
        component: PurchasesQuoteRequestComponent,
        // component: PurchasesQuoteRequestOldComponent,
      },
      {
        path: 'cotacao-fornecedor',
        component: PurchasesQuoteComponent,
      },
      //Operação
      {
        path: 'logistica',
        component: LogisticsComponent,
      },
      {
        path: 'ordem-servico',
        component: ServiceOrderComponent,
      },
      {
        path: 'compras',
        component: PurchasesComponent,
      },
      {
        path: 'reserva-compras',
        component: PurchaseReservationComponent,
      },
      // Financeiro
      {
        path: 'financeiro-operacao',
        component: FinancialOperationComponent,
      },
      {
        path: 'contrato-cliente',
        component: ContractComponent,
      },
      {
        path: 'agenda-frota',
        component: FleetScheduleComponent,
      },
      {
        path: 'acompanhamento-os',
        component: MonitoringComponent,
      },
      {
        path: 'monitoramento-os',
        component: MonitoringOsComponent,
      },
      {
        path: 'ocorrencias',
        component: OccurrencesComponent,
      },
    ],
  },
]
